export default __webpack_public_path__ + "static/media/HyperComplexSem_2021-08-26.6e260b90.zip";